// eslint-disable-next-line max-len
export const emailRegexp = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

export const isValidEmail = (email) => emailRegexp.test(email);

export const usPhoneRegexp = /(\+1 )?\(?[0-9]{3}\)? [0-9]{3}-? ?[0-9]{4}/;
